<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkdevice_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/device/parkdevice';
import { passageSelections } from '@/api/v4ward/park/passage/parkpassage';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { getDictionaryWithIntKey } from '@/api/common';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      operateType: '',
      selectionList: [],
      deviceBrandList: [],
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 4,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '50%',
        labelWidth: 150,
        span: 12,
        columnBtn: false,
        refreshBtn:false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            editDisabled: true,
            search: true,
            searchSpan: 5,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备类型',
            prop: 'deviceType',
            type: 'select',
            search: true,
            searchSpan: 4,
            maxlength: 20,
            dicUrl: '/api/blade-system/dict/dictionary?code=park_device_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择设备类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            search: true,
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入设备名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备型号',
            prop: 'deviceBrandTypeName',
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '设备型号',
            prop: 'deviceBrandType',
            type: 'select',
            maxlength: 15,
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择设备型号',
                trigger: 'change',
              },
            ],
            hide: true,
            viewDisplay: false,
          },
          {
            label: '品牌名称',
            prop: 'deviceBrandName',
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请选择品牌名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备编号',
            prop: 'deviceCode',
            search: true,
            searchSpan: 4,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入设备编号',
                trigger: 'change',
              },
              { pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/, message: '格式错误' },
            ],
          },
          {
            label: '所属通道',
            prop: 'passageName',
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '所属通道',
            prop: 'passageId',
            type: 'select',
            hide: true,
            viewDisplay: false,
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择设备所属通道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '排序号',
            prop: 'sort',
            rules: [
              {
                required: true,
                message: '请输入排序号',
                trigger: 'change',
              },
              { pattern: /^[1-9][+]?\d{0,8}$/, message: '请输入9位以内数字' },

            ],
          },
          {
            label: '通讯方式',
            prop: 'communicationType',
            maxlength: 15,
            hide: true,
          },
          {
            label: '通讯地址',
            prop: 'communicationAddress',
            maxlength: 32,
          },
          {
            label: '设备序列号',
            prop: 'serialNumber',
            hide: true,
            maxlength: 32,
          },
          {
            label: '端口',
            prop: 'port',
            value: 80,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入正确端口号',
                trigger: 'change',
              },
              {
                pattern: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
                message: '格式错误',
              },
            ],
          },
          {
            label: '连接凭证',
            prop: 'authentication',
            maxlength: 32,
            hide: true,
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            span:24,
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkdevice_add, false),
        viewBtn: this.vaildData(this.permission.parkdevice_view, false),
        delBtn: this.vaildData(this.permission.parkdevice_delete, false),
        editBtn: this.vaildData(this.permission.parkdevice_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.deviceType'() {
      this.loadDeviceBrand(this.form.deviceType);
    },
    'form.parkingLotId'() {
      this.form.passageId = '';
      let parkingLotIdTem = this.form.parkingLotId;
      if (this.vdui.isNotEmpty(parkingLotIdTem)) {
        this.loadPassageSelections(this.form.parkingLotId);
      }
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {

    loadPassageSelections(parkId) {
      if (typeof parkId === 'undefined') {
        return;
      }
      passageSelections({ parkId: parkId }).then((res) => {
        if (this.operateType === 'add') {
          this.form.passageId = null;
        }
        const column = this.findObject(this.option.column, 'passageId');
        column.dicData = res.data;
      });
    },
    loadDeviceBrand(deviceType) {
      if (this.deviceBrandList.length === 0) {
        getDictionaryWithIntKey('park_device_brand').then((res) => {
          this.deviceBrandList = res.data;
          this.updateDeviceBrandList(deviceType);
        });
      } else {
        this.updateDeviceBrandList(deviceType);
      }
    },
    updateDeviceBrandList(deviceType) {
      const column = this.findObject(this.option.column, 'deviceBrandType');
      if (typeof deviceType === 'undefined') {
        column.dicData = this.deviceBrandList;
      } else {
        column.dicData = this.deviceBrandList.filter(function (s) {
          return Math.floor(s.dictKey / 10) === deviceType;
        });
      }
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.query.parkingLotId = this.tempParkingLotId;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        //this.query.parkingLotId = this.tempParkingLotId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
